<template>
  <div class="notification-page auth-page-container">
    <h2 class="font-500 auth-page-title">{{ $t("account.notification") }}</h2>
    <section class="auth-page-section">
      <loader-block v-if="isLoading" :loading="true" />
      <ul
        class="notification-list"
        v-else-if="allNotifs && allNotifs.length"
      >
        <li
          v-for="item in allNotifs"
          :key="item.id"
          class="notification-item"
          :class="{ unread: !item.seen, seen: !!item.seen }"
          @click="markSeen(item)"
        >
          <div class="notification-row">
            <strong class="title">{{ item.title }}</strong>
            <span class="date">{{ item.created_at | formatDate }}</span>
          </div>
          <p class="body">{{ item.body }}</p>
        </li>
      </ul>
      <p v-else>{{ $t("account.no-notification") }}</p>
      <b-pagination-nav
        class="pt-4"
        v-if="!isLoading && allNotifs && allNotifs.length"
        v-model="page.number"
        align="center"
        :link-gen="linkGen"
        :number-of-pages="allNotifsPage.totalPages || 1"
        use-router
      />
    </section>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "NotificationPage",
  data() {
    return {
      isLoading: true,
      page: {
        number: 1,
      },
    };
  },
  computed: {
    ...mapState("user", ["allNotifs", "allNotifsPage"]),
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    ...mapActions("user", ["fetchNotifs", "seenNotif"]),
    async fetchData() {
      this.isLoading = true;
      try {
        await this.fetchNotifs({ page: this.page.number });
      } finally {
        this.isLoading = false;
      }
    },
    markSeen(item) {
      if (item.seen) return;
      this.seenNotif(item.id);
    },
    linkGen(pageNum) {
      return { query: { ...this.$route.query, page: pageNum } };
    },
  },
  watch: {
    "$route.query.page"() {
      this.page.number = parseInt(this.$route.query.page) || 1;
      this.fetchData();
    },
  },
};
</script>

<style lang="scss" src="./NotificationPage.scss"></style>
